import type { IGlobalSearchResponse } from '@moko/utils';
import { internalFetch } from '../utils/fetchHelper';

export type { IGlobalSearchResponse };

export const getGlobalSearch = async (
  abortController: AbortController,
  search: string
): Promise<IGlobalSearchResponse> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/globalSearch?search=${encodeURIComponent(search)}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};
